export const chatChannelTypes = ['INTERNAL', 'EXTERNAL', 'ANNOUNCEMENT'] as const;

export const reviewFormChannelTypes = ['REVIEW-FORM-ITEM'] as const;

export const bomItemChannelTypes = ['BOM-ITEM-INTERNAL'] as const;

export const wohCanvasChannelTypes = ['WOH-CANVAS-INTERNAL'] as const;

export const channelTypes = [
	...chatChannelTypes,
	...reviewFormChannelTypes,
	...bomItemChannelTypes,
	...wohCanvasChannelTypes,
] as const;
